// import React, { useContext, useState } from "react";
// import { Modal } from "react-bootstrap";
// import { organizationDetail } from "../../../Context/SelectedOrganization";
// import axios from "axios";

// const AddUserRoleModal = ({ isModalOpen, handleClose1 }) => {
//   const { organizationData } = useContext(organizationDetail);

//   const [roles, setRoles] = useState([{ role_name: "", status: 1 }]);
//   const [errors, setErrors] = useState({});
//   const [loading, setLoading] = useState(false);

//   const handleRoleChange = (index, field, value) => {
//     const updatedRoles = [...roles];
//     updatedRoles[index][field] = value;
//     setRoles(updatedRoles);
//   };

//   const addRoleField = () => {
//     setRoles([...roles, { role_name: "", status: 1 }]);
//   };

//   const deleteRoleField = (index) => {
//     const updated = roles.filter((_, i) => i !== index);
//     setRoles(updated);
//   };

//   const validate = () => {
//     let tempErrors = {};
//     roles.forEach((role, index) => {
//       if (!role.role_name.trim()) {
//         tempErrors[`role_${index}`] = "Role name is required";
//       }
//     });
//     setErrors(tempErrors);
//     return Object.keys(tempErrors).length === 0;
//   };

//   const handleSubmit = async () => {
//     if (!validate()) return;

//     const payload = {
//       organization_id: organizationData.id,
//       roles,
//     };
//     console.log("Payload to be sent:", payload);

//     try {
//       setLoading(true);
//       const response = await axios.post("/api/add-roles", payload);
//       console.log("API Response:", response.data);
//       handleClose1();
//     } catch (error) {
//       console.error("API Error:", error);
//     } finally {
//       setLoading(false);
//     }
//   };
//   return (
//     <div>
//       <Modal
//         className="all_supportss sm_sizess"
//         id="capture"
//         show={isModalOpen}
//         onHide={handleClose1}
//       >
//         <Modal.Header closeButton></Modal.Header>
//         <Modal.Body>
//           <div className="sher_mdl_area">
//             <h1>Organization Name : {organizationData?.organization_name}</h1>

//             {roles.map((role, index) => (
//               <div key={index} className="mb-3 d-flex gap-2 align-items-start">
//                 <div className="flex-grow-1">
//                   <label>Role Name</label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     value={role.role_name}
//                     onChange={(e) =>
//                       handleRoleChange(index, "role_name", e.target.value)
//                     }
//                   />
//                   {errors[`role_${index}`] && (
//                     <span className="text-danger">
//                       {errors[`role_${index}`]}
//                     </span>
//                   )}
//                 </div>

//                 {roles.length > 1 && (
//                   <button
//                     className="btn btn-danger mt-4"
//                     onClick={() => deleteRoleField(index)}
//                   >
//                     Delete
//                   </button>
//                 )}
//               </div>
//             ))}

//             <button
//               className="btn btn-secondary w-100 mt-2"
//               onClick={addRoleField}
//             >
//               + Add More Roles
//             </button>

//             <button
//               className="btn btn-secondary  w-100 mt-3"
//               onClick={handleSubmit}
//               disabled={loading}
//             >
//               {loading ? "Saving..." : "Submit"}
//             </button>
//           </div>
//         </Modal.Body>
//       </Modal>
//     </div>
//   );
// };

// export default AddUserRoleModal;

import { useContext, useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import Swal from "sweetalert2";
import { organizationDetail } from "../../../Context/SelectedOrganization";
import axiosClient from "../../../Services/Axios/axios";

const AddUserRoleModal = ({
  isModalOpen,
  handleClose1,
  getUserList,
  modalType,
  editRoleData,
}) => {
  const { organizationData } = useContext(organizationDetail);

  const [role, setRole] = useState({ role_name: "", status: 1 });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const validate = () => {
    let tempErrors = {};
    if (!role.role_name.trim()) {
      tempErrors.role_name = "Role name is required";
    }
    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handleClose = () => {
    setRole({ role_name: "", status: 1 });
    setErrors({});
    handleClose1();
  };

  const handleSubmit = async () => {
    if (!validate()) return;

    let payload = {};
    if (modalType === "edit") {
      payload = {
        id: editRoleData.id,
        organization_id: sessionStorage.getItem("organization_id"),
        readable: true,
        role_name: role.role_name,
        status: role.status,
      };
    } else {
      payload = {
        organization_id: sessionStorage.getItem("organization_id"),
        roles: [role],
      };
    }

    try {
      setLoading(true);
      const response = await axiosClient.post(
        `employees/${process.env.REACT_APP_API_VERSION}/role/${
          modalType === "add" ? "create" : "update"
        }`,
        payload
      );

      if (!response.data.error) {
        Swal.fire({
          title: response.data.message || "Role added successfully",
          icon: "success",
          timer: 1000,
          showConfirmButton: false,
        });
        setLoading(false);
        handleClose();
        getUserList();
      } else {
        setLoading(false);
        Swal.fire({
          title: "Error",
          text: response.data.message || "Failed to add role",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      console.error("API Error:", error);
      setLoading(false);
      Swal.fire({
        title: "Error",
        text: "An error occurred while adding the role",
        icon: "error",
        confirmButtonText: "OK",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (modalType === "edit") {
      setRole({
        role_name: editRoleData.role_name,
        status: editRoleData.status,
      });
    }
  }, [modalType]);

  return (
    <div>
      <Modal
        className="all_supportss sm_sizess"
        id="capture"
        show={isModalOpen}
        onHide={handleClose}
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <div className="sher_mdl_area">
            <h1>Organization Name : {organizationData?.organization_name}</h1>

            <div className="mb-3">
              <label>Role Name</label>
              <input
                type="text"
                className="form-control"
                value={role.role_name}
                onChange={(e) =>
                  setRole({ ...role, role_name: e.target.value })
                }
              />
              {errors.role_name && (
                <span className="text-danger">{errors.role_name}</span>
              )}
            </div>

            {/* ✅ Active / Inactive Radio Buttons */}
            <div className="mb-3">
              <label>Status</label>
              <div className="user-status-radio">
                <label className="user-status-radio-input">
                  <input
                    type="radio"
                    name="status"
                    value={1}
                    checked={role.status === 1}
                    onChange={() => setRole({ ...role, status: 1 })}
                  />{" "}
                  Active
                </label>

                <label className="user-status-radio-input">
                  <input
                    type="radio"
                    name="status"
                    value={0}
                    checked={role.status === 0}
                    onChange={() => setRole({ ...role, status: 0 })}
                  />{" "}
                  Inactive
                </label>
              </div>
            </div>

            <button
              className="btn btn-access btn-secondary w-100 mt-3"
              onClick={handleSubmit}
              disabled={loading}
            >
              {loading ? "Saving..." : "Submit"}
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default AddUserRoleModal;
